import Cookie from 'js-cookie';
import { fetchJson } from '../utils/http';
export const getTeamMembers = () => fetchJson('/api/v1/contacts/?pitchonly=1&orgmembers=1', {
  headers: {
    'X-CSRFToken': Cookie.get('csrftoken') || ''
  }
}).then(res => res.data);